// extracted by mini-css-extract-plugin
export var linkText = "_qw-0";